import type { TouringCaravanSchemeQuoteResult } from './SchemeQuoteResult'
import { JsonObject, JsonProperty } from 'json2typescript'
import PaymentTypeEnumConverter from '../../converters/PaymentTypeEnumConverter'
import { PaymentTypeEnum } from '../enums/DLDCommonValuesEnum'
import { DefinedListDetail } from './DefinedList'
import QuoteDetails from './QuoteDetails'

@JsonObject('TouringCaravanQuoteDetails')
export default class TouringCaravanQuoteDetails extends QuoteDetails<TouringCaravanSchemeQuoteResult> {
  @JsonProperty('voluntaryExcess', DefinedListDetail)
  voluntaryExcess: DefinedListDetail = new DefinedListDetail()
}

@JsonObject('TouringCaravanMTAQuoteDetails')
export class TouringCaravanMTAQuoteDetails extends TouringCaravanQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('hasUpgradableVAP', Boolean)
  hasUpgradableVAP = false

  @JsonProperty('message', String)
  message = ''

  @JsonProperty('hasClaims', Boolean)
  hasClaims = false
}

@JsonObject('TouringCaravanRenewalQuoteDetails')
export class TouringCaravanRenewalQuoteDetails extends TouringCaravanQuoteDetails {
  @JsonProperty('initialPaymentMethod', PaymentTypeEnumConverter)
  initialPaymentMethod: PaymentTypeEnum = PaymentTypeEnum.CardPayment

  @JsonProperty('previousPolicyScheme', String)
  previousPolicyScheme = ''
}
